import { render } from "./facial_verification_field.html?vue&type=template&id=89291dcc&scoped=true&external"
import script from "./FacialVerificationField.vue?vue&type=script&lang=js"
export * from "./FacialVerificationField.vue?vue&type=script&lang=js"

import "./facial_verification_field_base.css?vue&type=style&index=0&id=89291dcc&scoped=true&lang=css&external"
import "./facial_verification_field_layout.css?vue&type=style&index=1&id=89291dcc&scoped=true&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89291dcc"]])

export default __exports__